var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigthning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3L5.06908 12.6934C4.72752 13.1109 4.55674 13.3196 4.5552 13.4956C4.55385 13.6486 4.62267 13.7939 4.74196 13.8897C4.87916 14 5.14886 14 5.68825 14H12.0001L11.0001 21L18.931 11.3066C19.2726 10.8891 19.4434 10.6804 19.4449 10.5044C19.4463 10.3514 19.3774 10.2061 19.2581 10.1103C19.1209 10 18.8513 10 18.3119 10H12.0001L13.0001 3Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigthning);
export default __webpack_public_path__ + "static/media/ligthning.d95b2a58669ba67833bd217b96595914.svg";
export { ForwardRef as ReactComponent };